import type { Accommodation, DayRow } from '$/dto/ItineraryData.dto.ts';
import BookableVenueKind from '@/_constants/BookableVenueKind.ts';

export type BookingStay = Pick<
  Accommodation,
  'place' | 'city' | 'geoapify_place_id' | 'agoda_hotel_id' | 'agoda_city_id'
> & {
  check_in_day?: number;
  check_out_day?: number;
  booking_id?: string | null;
};

export type BookableStay = BookingStay & {
  check_in_day: number;
  check_out_day: number;
  booking_id: null;
  geoapify_place_id: string;
};

const MEALS: ReadonlySet<DayRow['item_type']> = new Set(['breakfast', 'lunch', 'dinner']);

const includesAny = (kinds: readonly string[], list: readonly string[]): boolean =>
  kinds.some((kind) => list.includes(kind));

export const isBookableRow = (row: DayRow): boolean => {
  if (MEALS.has(row.item_type) || row.booking_id) return false;

  const kinds = row.location?.venue_kinds ?? [];

  if (includesAny(kinds, BookableVenueKind.NEVER)) return false;

  return includesAny(kinds, BookableVenueKind.TICKETED) || includesAny(kinds, BookableVenueKind.LANDMARK);
};

export const isBookableStay = (stay: BookingStay): stay is BookableStay =>
  stay.booking_id === null &&
  typeof stay.check_in_day === 'number' &&
  typeof stay.check_out_day === 'number' &&
  Boolean(stay.geoapify_place_id);
